import { PageListCachedDataSource } from './BaseDataSources';
import { ITradingAccount } from '../Interfaces';

export class TradingAccountSource extends PageListCachedDataSource<ITradingAccount> {
  public constructor(entityId: number | null) {
    if (entityId === null || entityId === undefined) {
      super('/datasource/tradingaccounts');
    }
    else {
      super(`/datasource/tradingaccounts/${entityId}`);
    }
  }
}